class SilicateObject {
  #rawData = null;
  constructor(targetLanguage, rawData) {
    this.targetLanguage = targetLanguage;
    this.#rawData = rawData;
    this.groupId =
      targetLanguage === "en"
        ? this.#rawData.name_en || this.#rawData.group_en
        : this.#rawData.name_pt || this.#rawData.group_pt;
    this.description =
      targetLanguage === "en"
        ? this.#rawData.characteristic_en || this.#rawData.definition_en
        : this.#rawData.characteristic_pt || this.#rawData.definition_pt;
    this.minerals = JSON.parse(JSON.stringify(this.#rawData.minerals));
  }
}

export { SilicateObject };
